export const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss'
export const UPCOMING_DATE_FORMAT = 'PPPP @ p'
export const UPCOMING_TIME_FORMAT = 'p'
export const LOCAL_24HOUR_FORMAT = 'T'

export const LUXON_HUMAN_TIME_FORMAT = 'h:mm a'

export const DISPLAY_SMALL = 'small'
export const DISPLAY_MEDIUM = 'medium'
